import React, { useEffect, useState } from "react";
import moment from "moment";
// Components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderScc } from "../../../components/Landing/Header/headerScc";
import { CardsEvents } from "../components/Cards/cardsEvents";
import { Footer } from "../../../components/Landing/Footer";
import { Form, Select, Input, Button, Table, Empty } from "antd";
import apiMaestras from "../../../api/Maestras/api-maestras";
import "../PeopleList.scss";
// Hook
import { useLanding } from "../../../hooks/useLanding";
// style
import "../landing.style.scss";
import { coloresEstado } from "../../../constants/common";
import {
  obtenerColumnsTablaConvocatoria,
  handleFormFieldsChange,
} from "../../../utils/tablaConvocatoriaHelper";

import { AlternadorVista } from "../../../components/Generales/AlternadorVista";

export const Agenda = () => {
  // state component
  const {
    principalState,
    getConvocatorias,
    setPrincipalState,
    buscarconvocatorias,
    limipiarfiltros,
    loadingConvocatorias,
  } = useLanding();

  React.useEffect(() => {
    getLineasConvocatorias();
    handleLineaChange(430);
  }, []);

  const [LineasConvocatorias, setLineasConvocatorias] = React.useState([]);
  const [mostrarTabla, setMostrarTabla] = useState(false);

  const getLineasConvocatorias = async () => {
    try {
      const data = await apiMaestras.obtenerLineaConvocatoria();
      setLineasConvocatorias(Array.isArray(data) ? data : (data?.data || []));
    } catch (error) {
      setLineasConvocatorias([]);
    }
  };

  const fields = [
    { name: "perfil_participante", value: principalState.buscarconvocatorias.perfil_participante },
    { name: "area", value: principalState.buscarconvocatorias.area },
    { name: "entidad", value: principalState.buscarconvocatorias.entidad },
    { name: "linea_convocatoria", value: principalState.buscarconvocatorias.linea_convocatoria },
    { name: "categoria_linea_convocatoria", value: principalState.buscarconvocatorias.categoria_linea_convocatoria },
    { name: "buscar_palabra_clave", value: principalState.buscarconvocatorias.buscar_palabra_clave },
    { name: "tipo_convocatoria", value: principalState.buscarconvocatorias.tipo_convocatoria },
    { name: "anio", value: principalState.buscarconvocatorias.anio },
  ];

  const sortByFechaApertura = (a: any, b: any) => {
    const getAperturaDate = (conv: any) => {
      const fecha = conv.fechas?.find((f: any) => f.clave === "Apertura")?.valormin;
      return fecha ? moment(fecha).valueOf() : 0;
    };
    const dateA = getAperturaDate(a);
    const dateB = getAperturaDate(b);
    const now = moment().startOf("day").valueOf();

    const isPastA = dateA > 0 && dateA < now;
    const isPastB = dateB > 0 && dateB < now;

    if (isPastA && !isPastB) return 1;
    if (!isPastA && isPastB) return -1;

    return dateA - dateB;
  };

  const datosTabla = principalState.convocatoriasslice
    .filter((data: any) => data.entidad === "AGENDA CULTURAL")
    .sort(sortByFechaApertura)
    .map((data: any) => ({
      idconvocatorias: data.idconvocatorias,
      nombre_convocatoria: data.nombre_convocatoria,
      portada_url: data.portada_url,
      fechas: data.fechas,
      estado: data.estado,
      entidad: data.entidad,
      linea_convocatoria: data.linea_convocatoria,
      tipo_participante: data.tipo_participante,
      area: data.area,
    }));

  const columns = obtenerColumnsTablaConvocatoria(LineasConvocatorias, coloresEstado, true);

  const handleRowClick = (record: any) => {
    window.open(`/estimuloscultura/verconvocatoria/${record.idconvocatorias}`, "_blank", "noopener,noreferrer");
  };

  // component mounted
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getConvocatorias();
    }
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const [categorias, setCategorias] = useState<any>([]);
  const [filtros, setFiltros] = useState<any>({
    buscarpalabra: "",
    linea_convocatoria: null,
    categoria: null,
    estado: "",
  });

  const handleLineaChange = async (id_linea: number) => {
    try {
      let { data } = await apiMaestras.obtenerCategoriasPorLinea(id_linea);
      setCategorias(data);

      setFiltros({
        ...filtros,
        linea_convocatoria: id_linea,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <Header />
      <HeaderScc />

      <div className="container-fluid2 pt-5" style={{ marginTop: "0" }}>
        <div className="font-family-Montserrat text-center font-color-black" style={{ fontSize: 60 }}>
          <strong>
            <h1 className="mb-5" style={{ color: "#1e3a53" }}>
              AGENDA CULTURAL
            </h1>
          </strong>
          <h4 className="mb-3" style={{ textAlign: "center", marginTop: "10px" }}>
            Es la programación de encuentros y eventos ciudadanos de arte y cultura para la promoción y proyección de las expresiones culturales y del talento artístico de cada comuna y corregimiento del Distrito, que permite y fomenta el acceso y disfrute por parte de los habitantes del respectivo territorio.
          </h4>
        </div>
      </div>
      <br />
      <div className="container-fluid2 pt-4">
        <div className="row g-4 justify-content-center">
          <div className="col-12 col-lg-3">
            <div
              style={{
                position: "sticky",
                top: "100px",
                zIndex: 10,
              }}
            >
              <Form
                name="basic"
                size="large"
                layout="vertical"
                fields={fields}
                style={{
                  border: "1px solid #e2e8f0",
                  borderRadius: "18px",
                  padding: "24px",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                }}
                onFieldsChange={(changedFields) => handleFormFieldsChange(changedFields, principalState, setPrincipalState)}
              >
                <h5 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 700, color: "#1a365d", marginBottom: "16px" }}>
                  Filtros de Agenda
                </h5>
                <div className="row g-3">
                  <div className="col-12">
                    <Form.Item label="Palabra clave" name="buscar_palabra_clave" style={{ marginBottom: "14px" }}>
                      <Input style={{ borderRadius: "8px", fontSize: "16px" }} placeholder="Ej: Teatro, Comuna 10..." />
                    </Form.Item>
                  </div>
                  <div className="col-12">
                    <Form.Item label="Línea" name="categoria_linea_convocatoria" style={{ marginBottom: "14px" }}>
                      <Select
                        style={{ width: "100%", borderRadius: "8px" }}
                        placeholder="Seleccionar..."
                        onChange={(value: any, option: any) =>
                          setFiltros({ ...filtros, categoria: option.children })
                        }
                      >
                        {categorias.map(({ id, nombre }: any) => (
                          <Select.Option key={id} value={id}>
                            {nombre}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-12">
                    <Form.Item label="Expresiones culturales" name="area" style={{ marginBottom: "18px" }}>
                      <Select dropdownMatchSelectWidth={false} allowClear placeholder="Seleccionar...">
                        {principalState.area.map(({ nombre }: any) => (
                          <Select.Option key={nombre} value={nombre}>
                            {nombre}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <div className="col-12 d-flex flex-column gap-2">
                    <Button
                      style={{
                        backgroundColor: "#1a365d",
                        color: "#ffffff",
                        borderColor: "#1a365d",
                        borderRadius: "8px",
                        fontWeight: 600,
                        height: "42px",
                      }}
                      onClick={buscarconvocatorias}
                    >
                      Aplicar filtros
                    </Button>
                    <Button
                      style={{
                        borderRadius: "8px",
                        borderColor: "#cbd5e1",
                        fontWeight: 600,
                        color: "#64748b",
                        height: "40px",
                      }}
                      onClick={limipiarfiltros}
                    >
                      Limpiar
                    </Button>
                  </div>
                </div>
              </Form>
            </div>
          </div>

          <div className="col-12 col-lg-9">
            {/* Dock de control superior para Agenda */}
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4 p-3 bg-white border rounded-3 shadow-sm">
              <AlternadorVista mostrarTabla={mostrarTabla} alCambiar={setMostrarTabla} />
              <div className="text-muted" style={{ fontFamily: "Montserrat, sans-serif", fontSize: "14px", fontWeight: 600 }}>
                Mostrando <strong style={{ color: "#1a365d" }}>{datosTabla.length}</strong> eventos programados
              </div>
            </div>

            {mostrarTabla ? (
              <div className="modern-table-container">
                <Table
                  rowKey="idconvocatorias"
                  style={{ fontSize: "15px" }}
                  locale={{
                    emptyText: (
                      <Empty
                        description="No hay información para mostrar"
                        style={{ padding: "50px" }}
                      />
                    ),
                  }}
                  pagination={{
                    defaultPageSize: 10,
                    pageSizeOptions: ["10", "20", "50"],
                    showSizeChanger: true,
                    showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} eventos`,
                    className: "modern-custom-pagination",
                  }}
                  columns={columns}
                  dataSource={datosTabla}
                  size="middle"
                  bordered={false}
                  loading={loadingConvocatorias}
                  onRow={(record) => {
                    return {
                      onClick: () => handleRowClick(record),
                      style: {
                        cursor: "pointer",
                      },
                    };
                  }}
                />
              </div>
            ) : (
              <div>
                {datosTabla.length === 0 && !loadingConvocatorias ? (
                  <div className="modern-table-container text-center py-5">
                    <Empty description="No se encontraron eventos para este filtro" style={{ padding: "40px" }} />
                  </div>
                ) : (
                  <div className="row g-4">
                    {principalState.convocatoriasslice
                      .filter((data: any) => data.entidad === "AGENDA CULTURAL")
                      .sort(sortByFechaApertura)
                      .map((data: any) => (
                        <div key={`contenedor_${data.idconvocatorias}`} className="col-12 col-md-6 d-flex">
                          <CardsEvents key={data.idconvocatorias} convocatorias={data} />
                        </div>
                      ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="container-fluid2 pt-5 mb-5">
        <div style={{ width: "100%" }}>
          <div style={{ position: "relative", paddingBottom: "56.25%", paddingTop: 0, height: 0 }}>
            <iframe 
              title="Mapa Salas Abiertas 2026" 
              width="1920px" 
              height="1080px" 
              style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "none" }} 
              src="https://view.genially.com/6a57b803738c6baf171e82a3" 
              allowFullScreen 
            ></iframe> 
          </div> 
        </div>
      </div>

      <Footer />
    </div>
  );
};
